<template>
    <div
        class="app clearfix"
        style="width:100%"
    >

        <h-top></h-top>
        <div class="app">
            <div class="left-pic">
                <img src="../../assets/image/img/NewRegister/zc_left.png">
            </div>
            <div class="register-right">
                <div
                    class="logo"
                    @click="jumpIndex"
                ></div>
                <div class="register-box">
                    <div class="reg-box">
                        <p class="register_title">厨房网</p>
                        <p>您爱吃的菜这里都有</p>
                        <div style="margin-top: 4rem"></div>
                        <div
                            class="register-item-mobile"
                            style="margin: 1rem 0 0 0"
                        >
                            <input
                                type="number"
                                placeholder="请输入会员卡号或手机号"
                                v-model="phone"
                            />
                            <!--oninput="if(value.length>11)value=value.slice(0,11)"-->
                        </div>
                        <div
                            class="register-item-mobile"
                            style="margin: 1rem 0 0 0"
                        >
                            <input
                                type="password"
                                placeholder="请输入您的密码"
                                v-model="password"
                            />
                        </div>
                    </div>
                    <div
                        class="register-btn"
                        @click="loginClick"
                    >登录</div>


                    <div
                        style="width:100%;margin-top:1rem"
                        class="dis-between"
                    >
                        <div
                            class="forget-password"
                            style="color:#999999"
                            @click="forgotPassword"
                        >忘记密码?</div>
                        <div
                            class="noAccount-box"
                            style="color:#999999"
                            @click="regist"
                        >注册</div>
                    </div>
                </div>
            </div>

            <!-- 通用底栏 ----------------------------->
            <user-bottom
                v-if="is_userbottom"
                :parent-name="userbottomData"
            ></user-bottom>
            <!--@childFn="userbottomPopup"-->
        </div>
    </div>
</template>

<script>
    import UserBottom from './components/userBottom'
    import hTop from '../header/h-top.vue'
    export default
    {
        components:
        {
            UserBottom,
            hTop
        },
        data()
        {
            return {
                userbottomData: {},
                is_userbottom: true,
                // +----------------------------------
                phone: '', //用户账号
                password: "", //用户密码
            }
        },
        created()
        {
            localStorage.clear()
            localStorage.setItem( 'userStatusHTop', 'login' );
        },
        mounted()
        {

        },
        methods:
        {
            jumpIndex()
            {
                this.$router.push( { path: "/" } )
            },
            loginClick()
            {
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                if ( this.phone == '' )
                {
                    let name = '请输入会员卡号或手机号';
                    this.checkTips( name, 'warning' );
                }
                // ！手机号和会员卡号共用的
                // else if ( !telReg.test( this.phone ) )
                // {
                //     let name = '手机号格式错误！';
                //     this.checkTips( name, 'warning' );
                // }
                else if ( this.password == '' )
                {
                    let name = '请输入密码！';
                    this.checkTips( name, 'warning' );
                }
                else if ( this.password.length < 5 )
                {
                    let name = '请输入大于五位的密码！';
                    this.checkTips( name, 'warning' );
                }
                else
                {
                    let params = {
                        phone: this.phone,
                        password: this.password
                    }
                    this.$api.user.login( params ).then( res =>
                    {
                        this.$loading().close();
                        // console.log(res)
                        if ( res.data.code === 0 )
                        {
                            let name = '登录成功！';
                            this.checkTips( name, 'success' );
                            localStorage.setItem( 'token', res.data.result.token );
                            localStorage.setItem( 'username', res.data.result.userName );
                            localStorage.setItem( 'vipCard', res.data.result.vipCard );
                            localStorage.setItem( 'loginData', JSON.stringify( res.data.result ) )
                            this.$router.push(
                            {
                                path: "/"
                            } )
                        }
                        else
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'warning' );
                        }
                    } )
                }
            },
            regist()
            { //注册
                this.$router.push(
                {
                    path: '/regist'
                } )
            },
            forgotPassword()
            { //忘记密码
                this.$router.push(
                {
                    path: '/forgetPassword'
                } )
            },
            // autoLogin()
            // { //是否自动登录
            //     this.autoFlag = !this.autoFlag;
            // },
            //点击注册按钮
            registered()
            {
                this.$router.push(
                {
                    path: "/regist"
                } )
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
        },
        computed:
        {

        }
    }
</script>

<style scoped="scoped">
    .app {
        width: 97.5rem;
        margin: 0 auto;
    }

    .reg-box {
        height: 24rem;
    }

    .left-pic {
        float: left;
        width: 54rem;
        margin-top: 4.2rem;
        margin-left: 4rem;
    }

    .left-pic img {
        width: 100%;
    }

    .register-right {
        /* float: right;
        margin-top: 5.375rem; */
        position: fixed;
        top: 3.375rem;
        right: 6rem;
        z-index: 3;

    }

    .logo {
        width: 12.0625rem;
        height: 3.75rem;
        margin-left: 2.125rem;
        background-image: url(../../assets/image/img/NewRegister/logo.png);
        background-repeat: no-repeat;
        background-size: cover;
    }

    .register-box {
        /* width: 30.5rem;
        height: 41.75rem; */
        width: 26.5rem;
        height: 36.959rem;
        padding-top: 3.5rem;
        padding-left: 4rem;
        padding-right: 4rem;
        background-image: url(../../assets/image/img/NewRegister/zc_bg.png);
        background-repeat: no-repeat;
        background-size: cover;
    }

    .register_title {
        font-size: 2.25rem;
        font-weight: bold;
        color: #000000;
        line-height: 1em;
        margin-bottom: 1rem;
    }

    .register-chose label {
        float: left;
        font-size: 18px;
        line-height: 1em;
        display: inline-block;
        margin-left: -130px;
        margin-right: 20px;
        color: #000000;
    }

    .register-chose label:last-child {
        margin-right: 0;
    }

    .dis-between {
        display: flex;
        justify-content: space-between
    }

    .radio_type {
        float: left;
        /* width: 150px; */
        width: 50%;
        height: 20px;
        appearance: none;
        position: relative;
        cursor: pointer;
    }

    .radio_type:before {
        content: '';
        width: 18px;
        height: 18px;
        border: 1px solid #11D164;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .radio_type:checked:before {
        content: '';
        width: 18px;
        height: 18px;
        border: 1px solid #11D164;
        background: #11D164;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .radio_type:checked:after {
        content: '';
        width: 9px;
        height: 5px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 5px;
        left: 4px;
        vertical-align: middle;
        transform: rotate(-45deg);
    }

    .register-item-mobile {
        /* margin-top: 3.125rem; */
        margin-top: 0
    }

    .register-item-mobile input {
        /* width: 22.5rem; */
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
    }

    .register-item-code {
        /* width: 22.5rem; */
        width: 100%;
        margin-top: 1rem;
    }

    .register-item-code input {
        float: left;
        width: 9.5rem;
        height: 2.3rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        border: none;
        background: #F2F4FF;
        border-radius: 8px;
    }

    .send-btn {
        float: right;
        width: 8.75rem;
        border-radius: 8px;
        font-size: 16px;
        color: #434343;
        line-height: 2.3rem;
        text-align: center;
        float: right;
        background-color: #F2F4FF;
        cursor: pointer;
    }

    .register-item-pwd {
        margin-top: 0;
    }

    .register-item-pwd input {
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
        margin: 1rem 0 0 0
    }

    .register-agreement {
        width: 22.5rem;
        margin-top: 1rem;
    }

    .checkbox_type {
        float: left;
        width: 13.125rem;
        height: 14px;
        appearance: none;
        position: relative;
        cursor: pointer;
    }

    .checkbox_type:before {
        content: '';
        width: 14px;
        height: 14px;
        border: 1px solid #11D164;
        display: inline-block;
        vertical-align: middle;
        border-radius: 3px;
    }

    .checkbox_type:checked:before {
        content: '';
        width: 14px;
        height: 14px;
        border: 1px solid #11D164;
        background: #11D164;
        display: inline-block;
        vertical-align: middle;
    }

    .checkbox_type:checked:after {
        content: '';
        width: 8px;
        height: 4px;
        border: 2px solid white;
        border-top: transparent;
        border-right: transparent;
        text-align: center;
        display: block;
        position: absolute;
        top: 4px;
        left: 3px;
        vertical-align: middle;
        transform: rotate(-45deg);
    }

    .register-agreement p {
        float: left;
        color: #999999;
        font-size: 16px;
        line-height: 18px;
        margin-left: -186px;
    }

    .register-agreement a {
        color: #11D164;
        display: inline-block;
    }

    .register-btn {
        width: 100%;
        background-color: #11D164;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 2.3rem;
        text-align: center;
        border-radius: 8px;
        margin-top: 1rem;
        cursor: pointer;
        /* margin: 4rem 0 0 0 */
    }

    .register-login {
        width: 100%;
        margin-top: 1rem;
        text-align: center;
        color: #999999;
    }

    .register-login a {
        display: inline-block;
        color: #11D164;
    }

    .reg-qy {
        width: 100%;
        height: 18rem;
        background-color: #f1f1f1;
        border-radius: 2rem;
        margin: 1rem 0
    }

    .reg-popup-bac {
        width: 100%;
        height: 100vh;
        background-color: #000000;
        opacity: 0.8;
    }

    .req-popup-pos {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }

    .reg-popup-wid {
        width: 100%;
        height: 100vh;
    }

    .reg-popup-box {
        width: 35rem;
        height: 26.5rem;
        background-color: #ffffff;
        border-radius: 2rem;
        padding: 2rem;
        box-sizing: border-box;
    }

    .dis-cen {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center
    }

    .reg-popup-code {
        width: 100%;
        height: 13rem;
        border: 1px solid #f1f1f1;
        margin: 1.5rem 0 0 0
    }

    .select-css {
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
        margin: 1rem 0 0 0;
    }

    input {
        outline: none;
    }
</style>